import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SurveyPerson } from "types";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getIdentificationTypes } from "app/features/surveySlice";
import { personSurveyReceivedMapper } from "lib/helpers/surveyHelper";
import SurveyManageUsersForm from "components/Forms/SurveyManageUsersForm/SurveyManageUsersForm";
import { useParams } from "react-router-dom";
import { getContriesArea } from "app/features/placesSlice";
import {
  getPerson,
  savePerson,
  hidePersonToast,
  clearPersonError,
  clearPersonResponse,
} from "app/features/personSlice";
import { getToastMessage } from "lib/helpers/toastMessageHelper";
import NewToast from "ui/atoms/NewToast";
import FormCard from "components/Forms/FormCard/FormCard";
import withAuth from "lib/hoc/withAuth";

const UserSurveyEdit = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const param = useParams();
  const personId: number = Number(param.userId);
  const { countryCodes } = useAppSelector((state) => state.places);
  const { surveyPerson, personError, personResponse, personShowToast, personSeverity, personLoading } = useAppSelector(
    (state) => state.person
  );
  const { identificationTypes } = useAppSelector((state) => state.survey);

  const onEditSurveyUser = async (surveyUser: SurveyPerson) => {
    const response = (await dispatch(savePerson(surveyUser))) as any;
    if (response?.error?.message === "Rejected") {
      return;
    }
    setTimeout(() => {
      navigate("/survey/send", { replace: false });
    }, 800);
  };

  const clearToast = () => {
    dispatch(hidePersonToast());
    dispatch(clearPersonResponse());
    dispatch(clearPersonError());
  };

  useEffect(() => {
    dispatch(getIdentificationTypes());
    dispatch(getContriesArea());
    dispatch(getPerson({ identificationNumber: personId }));
    return () => {
      clearToast();
    };
  }, []);

  const surveyPersonMapped = personSurveyReceivedMapper(surveyPerson);

  return (
    <>
      <NewToast open={personShowToast} setOpen={clearToast} severity={personSeverity}>
        {getToastMessage(personResponse, personError)}
      </NewToast>
      <FormCard maxWidthCard={775} maxWidthContainer='md' title='Editar Encuestado'>
        <SurveyManageUsersForm
          disabled
          loading={personLoading}
          handleSubmit={onEditSurveyUser}
          submitButtonText='Editar Encuestado'
          identificationTypes={identificationTypes}
          countryCodes={countryCodes}
          model={surveyPersonMapped}
        />
      </FormCard>
    </>
  );
};

export default withAuth(UserSurveyEdit);
